import React from "react";
import ContactBlock from "./ContactBlock";

const ContactWrap = ({
                         contactType,
                         isMultiple,
                         accounts,
                         onContactSelect,
                         selectedContacts,
                         skipCreate = false,
                         disabledText = null,
                         disabled = false,
                         onUserCreated,
                         onRemoveContact,
                         isPrimary = false

                     }) => {

    const {title, subtitle, id} = contactType;

    return <div className={"sl-flex sl-flex-col"}>
        {title && <span
            className={"sl-text-gray-900 sl-font-medium sl-font-normal sl-text-lg sl-font sl-pb-8px"}>{title}</span>}
        <div
            className={`sl-flex sl-flex-row sl-align-flex-start sl-gap-10`}>
            <div className={"sl-flex sl-shrink-0 sl-flex-col sl-text-left sl-w-138"}>

                <span
                    className={`sl-text-gray-700 sl-font-normal sl-font-normal ${isPrimary ? 'sl-text-md' : 'sl-text-sm'} sl-font`}>{subtitle}</span>
            </div>

            <div className={"sl-w-full sl-grow-0 sl-flex sl-flex-col sl-gap-2"}>
                <ContactBlock
                    onRemoveContact={onRemoveContact}
                    onUserCreated={onUserCreated}
                    type={id}
                    selectedContacts={selectedContacts}
                    isPrimary={isPrimary}
                    disabled={disabled} allVendorAccounts={accounts} isMultiple={isMultiple}
                    onContactSelect={onContactSelect}
                    skipCreate={skipCreate}/>

                {disabled && <span className={"sl-text-gray-500 sl-font sl-text-sm sl-font"}>{disabledText}</span>}
            </div>
        </div>
    </div>
}

export default ContactWrap;